import React from 'react';
import ErrorBoundaryO, {FallbackRenderFn} from "./ErrorBoundaryO";

export type ErrorBoundaryOptions = {
    name: string;
    shouldUseErrorFrame?: boolean;
    shouldUseErrorIcon?: boolean;
    fallbackRender?: FallbackRenderFn;
}

/**
 * @param {<T extends JSXElementConstructor>} Component
 * @param {ErrorBoundaryOptions} options - options for the component
 */
export default function withErrorBoundary<P extends object>(
    Component: React.ComponentType<P>,
    options: ErrorBoundaryOptions
) {
    const WrappedComponent = (props: P) => {
        return (
            <ErrorBoundaryO
                uniqueKey={options.name}
                shouldUseErrorFrame={options.shouldUseErrorFrame}
                shouldUseErrorIcon={options.shouldUseErrorIcon}
                fallbackRender={options.fallbackRender}
            >
                <Component {...props as any}/>
            </ErrorBoundaryO>
        );
    };

    WrappedComponent.displayName = `withErrorBoundary(${options.name || Component.displayName || Component.name || 'Component'})`;

    return WrappedComponent;
}